module.exports = __webpack_public_path__ + "static/media/DragAndDrop1.26ab28e1.png";